import React from 'react';
import {useCheckIfAdmin} from "../firebase/useCheckIfAdmin";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {Helmet} from "react-helmet";
import {useNavigate} from "react-router";
import {EmailContent} from "./EmailContent";
import {UnauthorizedAccess} from "../app/UnauthorizedAccess";

export const Email = () => {
    const navigate = useNavigate();
    const isAdmin = useCheckIfAdmin();

    if (!isAdmin) {
        return <UnauthorizedAccess requiredRole="administrator" />;
    }

    return (
        <Container maxWidth="md" sx={{ py: 3, px: {xs: 2, sm: 3} }}>
            <Helmet>
                <title>Send e-post til kursholdere | Bekymringsmestring</title>
            </Helmet>

            <Box sx={{ mb: 3 }}>
                <Button
                    startIcon={<ArrowBackIcon />}
                    onClick={() => navigate("/me")}
                    sx={{
                        mb: 2,
                        color: "text.secondary",
                        textTransform: "none",
                        fontWeight: 600,
                        borderRadius: 2,
                        minHeight: 44,
                        "&:hover": { color: "primary.main" },
                        "&:focus-visible": { outline: "2px solid #285238", outlineOffset: 2 },
                    }}
                >
                    Tilbake til Min side
                </Button>

                <Typography
                    variant="h4"
                    component="h1"
                    sx={{ fontWeight: 700, color: "primary.main", mb: 0.5 }}
                >
                    E-post til kursholdere
                </Typography>
                <Typography variant="body1" color="text.secondary">
                    Send felles e-post eller kunngjøring til alle registrerte og godkjente kursholdere.
                </Typography>
            </Box>

            <Paper
                elevation={0}
                sx={{
                    p: {xs: 2.5, sm: 4},
                    borderRadius: 3,
                    border: "1px solid rgba(40, 82, 56, 0.12)",
                    boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)",
                }}
            >
                <EmailContent />
            </Paper>
        </Container>
    );
};